import AgendamentosDropdown from '../Dropdown/AgendamentosDropdown';
import OportunidadeDropdown from '../Dropdown/OportunidadeDropdown';
import React, { useState, useEffect, useMemo } from 'react';

// Importa os componentes dos formulários (assumindo que estão no mesmo nível)
import FormularioFornecedor from '../Formulario/FormularioFornecedor';
import FormularioCliente from '../Formulario/FormularioCliente';
import FormularioOportunidade from '../Formulario/FormularioOportunidade';
import FormularioContrato from '../Formulario/FormularioContrato';
import FormularioProducao from '../Formulario/FormularioProducao';

import '../sidebar/Sidebar.css';

export default function Sidebar({ inicial, clienteSelecionado }) {
  // Estado para popup de escolha de cliente
  const [mostrarPopupClientes, setMostrarPopupClientes] = useState(false);
  
  const itens = useMemo(() => [
    'Cliente'
  ], []);

  const [ativo, setAtivo] = useState(itens[0]);

  const renderConteudo = () => {
    switch (ativo) {
      case 'Cliente': 
        return (
          <FormularioCliente 
            cliente={clienteSelecionado} 
            onSalvar={() => {
              alert('Cliente atualizado com sucesso!');
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            }} 
          />
        );
      default: 
        return (
          <FormularioCliente 
            cliente={clienteSelecionado} 
            onSalvar={() => {
              alert('Cliente atualizado com sucesso!');
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            }} 
          />
        );
    }
  };

  const handleVoltar = () => {
    window.location.reload(); // Atualiza a página atual
  };

  return (
    <div style={{ display: 'flex', height: '100vh' }}>
      <nav className="sidebar">
        <button
          className="sidebar-button-voltar"
          onClick={handleVoltar}
          aria-label="Voltar"
          type="button"
          style={{ borderRadius: 0 }}
        >
          <span className="seta-voltar">&#8592;</span>
        </button>

        {itens.map((item) => (
          <div
            key={item}
            className={`sidebar-item ${ativo === item ? 'active' : ''}`}
            onClick={() => setAtivo(item)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') setAtivo(item); }}
          >
            {item}
          </div>
        ))}
      </nav>

      <main className="content">
        {renderConteudo()}
      </main>
    </div>
  );
}
